// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from "./http/http"
import "babel-polyfill" //解决Ie白屏问题对es6语法不支持
import JsEncrypt from "jsencrypt"//RSA加密
import compress from './assets/js/compress.js'//图片压缩封装
import Cookies from 'js-cookie'
import {
  Pagination,
  Carousel,
  CarouselItem,
  MessageBox,
  Loading,
  Form,
  FormItem,
  Input,
  Button,
  Select,
  Option,
  OptionGroup,
  ButtonGroup,
  Col,
  DatePicker,
  TimePicker,
  TimeSelect,
  Switch,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Steps,
  Step,
  Cascader,
  Upload,
  Table,
  TableColumn,
  Autocomplete
} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/base.styl'
import qs from 'qs'
Vue.prototype.$http=axios
Vue.prototype.$Cookies=Cookies
Vue.prototype.$qs = qs
Vue.prototype.$compress = compress;
// axios.defaults.baseURL = 'http://www.test.com/CqepcYX/WebApi/api'; 
//  axios.defaults.baseURL = 'http://192.168.0.80/CqepcYX/WebAPI/api';
//  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.prototype.$jsEncrypt = function (parms) {
  let encrypt = new JSEncrypt();
  encrypt.setPublicKey("MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCK4n2xrbtnRyBqMJ2iiDeDRdJ/F8EVmzcjSGy/vVNfEVahl6sQOjQXZTc8AEbiZdyLnP9QwX3ZkIsEGUz1VMaPUJeHLHQC5uVljRWR0ORt4oiU7mtN5ZsEl8gPQBzSbC7IpnXVRN1Mx7s/RlFsWZgkuZKbPjxcfgoA9zXyhmcHywIDAQAB");
  let data = encrypt.encrypt(parms);
  return data;
}
Vue.config.productionTip = false
Vue.use( Pagination)
Vue.use( Carousel)
Vue.use( CarouselItem)
Vue.use( Loading)
Vue.use( Form)
Vue.use( FormItem)
// Vue.use( MessageBox)
Vue.use( Input)
Vue.use( Button)
Vue.use( Select)
Vue.use( Option)
Vue.use( OptionGroup)
Vue.use( ButtonGroup)
Vue.use( Col)
Vue.use( DatePicker)
Vue.use( TimePicker)
Vue.use( TimeSelect)
Vue.use( Radio)
Vue.use( RadioGroup)
Vue.use( RadioButton)
Vue.use( Checkbox)
Vue.use( CheckboxButton)
Vue.use( CheckboxGroup)
Vue.use( Switch)
Vue.use( Steps)
Vue.use( Step)
Vue.use( Cascader)
Vue.use( Upload)
Vue.use( Table)
Vue.use( TableColumn)
Vue.use( Autocomplete)
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js